(() => {
  const config = document.querySelector('[data-paragon-replo-cta-ids]');
  if (!config) return;
  const selector = config.dataset.paragonReploCtaIds.split(',').map((id) => `[data-rid="${id.trim()}"]`).join(',');
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element) || !event.target.closest(selector)) return;
    const target = document.getElementById(config.dataset.paragonReploCtaTarget) || config;
    event.preventDefault();
    event.stopImmediatePropagation();
    history.replaceState(null, '', `#${target.id}`);
    target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
  }, true);
})();
